import { Col, Row, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import CoverImage from '../../components/cover-image/cover-image';
import RentalDetailsFilterComponent from '../../components/rental-details/rental-details-filter.component';
import CarGallery from './car-gallery.component';
import CarSignUpBanner from './car-sign-up-banner';
import FindCarBanner from './find-a-car-banner';
const { Title } = Typography;

const WelcomePage: React.FC = function () {
  return (
    <>
      <StyledCoverImage style={{ height: 280 }} />
      <WelcomeWrapperCol offset={2} span={20}>
        <TitleRow>
          <MainTitle className="hide-below-md">
            Find your drive. <br />
            <Col xs={0} sm={1}>
              <i>Fast.</i>
            </Col>
          </MainTitle>
        </TitleRow>
        <RentalDetailsFilterComponent />
        <Row className="show-below-md">
          <Title level={3} className="mobile-title">
            Find your drive. <i>Fast.</i>
          </Title>
        </Row>
        <Row>
          <Title level={4} className="meet-the-fleet">
            Meet the fleet
          </Title>
        </Row>
        <CarGallery />
        <FindCarBanner style={{ marginBottom: 25 }} />
        <CarSignUpBanner />
      </WelcomeWrapperCol>
    </>
  );
};

const StyledCoverImage = styled(CoverImage)``;

const WelcomeWrapperCol = styled(Col)`
  .mobile-title {
    color: #000;
    margin-top: 30px;
    margin-bottom: 0;
  }

  .meet-the-fleet {
    margin: 20px;
  }

  @media only screen and (max-width: 768px) {
    padding-top: 60px;

    .meet-the-fleet {
      margin: 44px 0 12px 0;
    }
  }

  padding-top: 240px;
  z-index: 1;
  width: 1000px;
  position: 'relative';
`;

const TitleRow = styled(Row)`
  position: absolute;
  top: 35px;
`;

const MainTitle = styled.h1`
  color: white;
`;

const StyledWelcomePage = styled(WelcomePage)`
  background-color: white;
`;

export default StyledWelcomePage;
